// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5682 ? "09b49e86" : chunkId) + "." + {"5682":"6a1dda7ee9ce547a","9795":"0c719c98a25129cb"}[chunkId] + ".js";
};